
































import {Component, Vue, Watch} from "vue-property-decorator";
import store from '@/store'
import MetaSetting from "@/plugins/meta"
import {mapGetters} from "vuex";
import {SUPPORTED_LOCALES} from '@/common/locale';

@Component({
    components: {},
})
export default class App extends Vue {
    // metaInfo:{
    //     title:'ZEMPIE',
    //     titleTemplate:'게임 공유 플랫폼',
    // }
    path = "/";
    locales =  SUPPORTED_LOCALES;

    async mounted() {
        await this.$store.dispatch("loginState");

        //  if( state === LoginState.login ) {
        //     if( !this.$store.getters.user.is_developer ) {
        //         await this.$router.replace('/signup').catch(()=>{});
        //     }
        // }
        // else {
        //     await this.$router.replace('/login');
        // }
    }

    moveLogin() {
        this.$modal.hide('needLogin')
        this.$router.push(`/${this.$i18n.locale}/login`)
    }


}
